"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = void 0;
const gqlClient_1 = require("../../utils/gqlClient");
const wrapQuery_1 = require("../../utils/wrapQuery");
const config_1 = require("../../utils/config");
const loginQuery = gqlClient_1.gql `
  query Login(
    $email: String!
    $password: String!
    $client: String!
    $forceMfa: Boolean
    $deviceId: String
  ) {
    userTokens(
      params: {
        email: $email
        password: $password
        clientId: $client
        forceMfa: $forceMfa
        deviceId: $deviceId
      }
    ) {
      tokens {
        idToken
        accessToken
        expires
      }
    }
  }
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const errorCodes = gqlClient_1.gql `
  #this query is only here to enable code generating of ErrorCodes enum
  query GetErrorCodes {
    getErrorCodes
    getMfaErrorPayload {
      mfa_token
      uuid
      email
    }
  }
`;
function login(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield wrapQuery_1.wrapQuery('login', loginQuery, Object.assign(Object.assign({}, params), { client: config_1.getClientId() }));
        return data.userTokens.tokens;
    });
}
exports.login = login;
